module.exports = __webpack_public_path__ + "static/media/pc4.92ebad3a.png";